import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { BlogLayout } from '../../components/BlogLayout';
import { ArchiveTable } from '../../components/ArchiveTable';
import { api } from '../../lib/api';
import type { Post } from '../../lib/types';
import { PageHeader } from '../../components/PageHeader';

export default function ArchivePage() {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchPosts() {
      try {
        const response = await api.get<Post[]>('/api/v1/posts');
        if (response.success && response.data) {
          setPosts(response.data);
        } else {
          setError(response.error?.message || 'Failed to load posts');
        }
      } catch (err) {
        setError('Failed to load posts');
      } finally {
        setLoading(false);
      }
    }
    fetchPosts();
  }, []);

  return (
    <BlogLayout>
      <Helmet>
        <title>Archive - QuestFlow</title>
        <meta name="description" content="Browse all QuestFlow posts - filter by title, author, category, or tag" />
      </Helmet>
      <div className="page-body archive-page">
        <PageHeader
          title="Full Archive"
          eyebrow="Questflow"
          description="Scan every published briefing by title, author, date, category, or tag."
        />

        {loading ? (
          <p className="placeholder">Loading archive...</p>
        ) : error ? (
          <p className="form-error">{error}</p>
        ) : (
          <ArchiveTable posts={posts} />
        )}
      </div>
    </BlogLayout>
  );
}
